module.exports = "fragment CalendarDateFragment on CalendarDate {\n  __typename\n  day\n  month\n  year\n}\n"